import React from "react";
import styles from "./tag.module.scss";

interface TagProps {
  whitelistStartDate?: string;
  whitelistEndDate?: string;
  saleStartDate?: string;
  saleEndDate?: string;
  stage?: string;
  title?: string;
}

const Tag: React.FC<TagProps> = ({
  whitelistStartDate,
  whitelistEndDate,
  saleStartDate,
  saleEndDate,
  stage,
  title,
}) => {
  const now = new Date();

  if (saleEndDate && new Date(saleEndDate) <= now) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.idoEnded}`}>IDO Sold Out</span>
      </div>
    );
  }

  if (
    stage === "whitelist" &&
    (!whitelistStartDate || whitelistStartDate.trim() === "")
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.whitelistOpen}`}>
          Whitelist Soon
        </span>
      </div>
    );
  }

  if (
    stage === "whitelist" &&
    title === "XProtocol IDO | SmartWhitelist" &&
    (!whitelistStartDate || whitelistStartDate.trim() === "")
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.whitelistOpen}`}>
          SmartWhitelist Soon
        </span>
      </div>
    );
  }

  if (
    whitelistStartDate &&
    title === "XProtocol IDO | SmartWhitelist" &&
    new Date(whitelistStartDate) > now
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.whitelistOpen}`}>
          SmartWhitelist Soon
        </span>
      </div>
    );
  }

  if (whitelistStartDate && new Date(whitelistStartDate) > now) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.whitelistOpen}`}>
          Whitelist Soon
        </span>
      </div>
    );
  }

  if (
    title === "XProtocol IDO | SmartWhitelist" &&
    whitelistStartDate &&
    whitelistEndDate &&
    new Date(whitelistStartDate) <= now &&
    new Date(whitelistEndDate) > now
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.whitelistOpen}`}>
          SmartWhitelist Open
        </span>
      </div>
    );
  }

  if (
    whitelistStartDate &&
    whitelistEndDate &&
    new Date(whitelistStartDate) <= now &&
    new Date(whitelistEndDate) > now
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.whitelistOpen}`}>
          SmartWhitelist Open
        </span>
      </div>
    );
  }

  if (
    whitelistEndDate &&
    saleStartDate &&
    new Date(whitelistEndDate) <= now &&
    new Date(saleStartDate) > now
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.idoSoon}`}>IDO Soon</span>
      </div>
    );
  }

  if (
    saleStartDate &&
    saleEndDate &&
    new Date(saleStartDate) <= now &&
    new Date(saleEndDate) > now
  ) {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.idoOpen}`}>IDO Open</span>
      </div>
    );
  }

  if (stage === "fcfs") {
    return (
      <div className={styles.tags}>
        <span className={`${styles.tag} ${styles.fcfs}`}>FCFS Open</span>
      </div>
    );
  }

  return null;
};
export default Tag;
